import React from "react";

// Pill button. variant: terracotta | dark | light | outline
export const PillButton = React.forwardRef(
  ({ children, variant = "terracotta", as = "button", className = "", ...props }, ref) => {
    const base =
      "group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-[transform,box-shadow,background-color,color] duration-300 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta/50 cursor-pointer";
    const variants = {
      terracotta:
        "bg-terracotta text-white shadow-[0_8px_24px_-8px_rgba(201,123,74,0.55)] hover:shadow-[0_14px_34px_-8px_rgba(201,123,74,0.6)] hover:bg-[#bd6f40]",
      dark:
        "bg-ink text-cream shadow-[0_8px_24px_-10px_rgba(43,38,32,0.6)] hover:shadow-[0_14px_34px_-10px_rgba(43,38,32,0.55)] hover:bg-black",
      light:
        "bg-cream text-ink shadow-[0_8px_24px_-10px_rgba(0,0,0,0.35)] hover:shadow-[0_14px_34px_-10px_rgba(0,0,0,0.3)]",
      outline:
        "border border-[rgba(43,38,32,0.2)] text-ink hover:bg-ink hover:text-cream hover:border-ink",
    };
    const Comp = as;
    return (
      <Comp ref={ref} className={`${base} ${variants[variant]} ${className}`} {...props}>
        {children}
      </Comp>
    );
  }
);
PillButton.displayName = "PillButton";
